<template>
  <b-card no-body>
    <div class="card-header">
      <b-icon-person></b-icon-person> {{ $t('user.login') }}
    </div>
    <b-alert show variant="danger" dismissible v-if="authFailed">
      <h3 class="alert-heading">{{ $t('messages.error') }}</h3>
      {{ $t('messages.actions.login_failed') }}</b-alert
    >
    <b-form action="#" @submit.prevent="login">
      <b-list-group flush>
        <b-list-group-item>
          <b-form-group
            label-cols="12"
            label-cols-sm="4"
            label-cols-lg="3"
            label-for="email"
            :label="$t('user.email_label') + ':'"
          >
            <b-input-group>
              <b-input
                type="email"
                id="email"
                placeholder="mail@example.com"
                v-model="user.userName"
                required
              ></b-input>
            </b-input-group>
          </b-form-group>

          <b-form-group
            label-cols="12"
            label-cols-sm="4"
            label-cols-lg="3"
            label-for="password"
            :label="$t('user.password_label') + ':'"
          >
            <b-input-group>
              <b-input
                type="password"
                id="password"
                v-model="user.password"
                required
              ></b-input>
            </b-input-group>
          </b-form-group>
        </b-list-group-item>

        <b-alert show variant="light">
          <p class="text-center">
            <router-link :to="{ name: 'Forgot password' }">{{
              $t('user.forgot_password_label')
            }}</router-link>
          </p>
        </b-alert>
      </b-list-group>
      <b-card-footer>
        <b-button variant="primary" type="submit" :disabled="submitting">
          {{ $t('user.login') }}
        </b-button>
      </b-card-footer>
    </b-form>
  </b-card>
</template>
<script>
import api from '../api/api';

export default {
  data() {
    return {
      user: {
        userName: '',
        password: '',
      },
      submitting: false,
      authFailed: false,
    };
  },
  methods: {
    login() {
      this.submitting = true;
      this.user.userName.trim();
      const userData = JSON.stringify(this.user);

      api
        .login(userData)
        .then((res) => {
          if (res.data.success) {
            sessionStorage.setItem('api_token', res.data.apiToken);
            this.$store.dispatch('getUser');
            this.$router.push({ name: 'Root' });
          } else {
            setTimeout(() => (this.authFailed = true), 1000);
          }
        })
        .catch((err) => setTimeout(() => (this.authFailed = true), 1000))
        .finally(() => (this.submitting = false));
    },
  },
};
</script>
<style lang="scss" scoped>
.alert-light {
  height: 40px;
}
</style>
